import { ExternalBridgeType } from '@types';
import type { ExternalBridge } from './types';
import { getUrlWithBasePath } from '@lib/utils';

export const EXTERNAL_BRIDGES: ExternalBridge[] = [
  // {
  //   name: 'XY Finance',
  //   type: ExternalBridgeType.XyFinance,
  //   iconSrc: getUrlWithBasePath('/assets/images/icons/xy-finance.svg'),
  //   link: 'https://app.xy.finance?fromTokenAddress=0x271602A97027ee1dd03b1E6e5dB153eB659A80b1&sourceChainId=388&targetChainId=25&toTokenAddress=0xe44Fd7fCb2b1581822D0c862B68222998a0c299a',
  //   info: 'The main route is vETH-wETH when transferring between Cronos zkEVM and Cronos EVM',
  // },
  {
    name: 'Symbiosis',
    type: ExternalBridgeType.Symbiosis,
    iconSrc: getUrlWithBasePath('/assets/images/icons/symbiosis.svg'),
    link: 'https://app.symbiosis.finance/bridge?chainIn=Boba%20BNB&chainOut=Cronos&syntheticIn=1&syntheticOut=0&tokenIn=0xBF73aF83aE56Ce393737faFcC4778Aa5751d1552&tokenOut=0xc21223249CA28397B4B6541dfFaEcC539BfF0c59',
  },
  {
    name: 'Relay',
    iconSrc: getUrlWithBasePath('/assets/images/icons/relay-dark.svg'),
    type: ExternalBridgeType.Relay,
    link: 'https://www.relay.link/bridge/cronos',
  },
  {
    name: 'Stargate',
    iconSrc: getUrlWithBasePath('/assets/images/icons/stargate-dark.svg'),
    type: ExternalBridgeType.Stargate,
    link: 'https://stargate.finance/bridge?srcChain=ethereum&srcToken=0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE&dstChain=cronosevm&dstToken=0xf44acfdC916898449E39062934C2b496799B6abe',
  },
];
